// Authentication configuration - centralized environment variable handling
export const AUTH_CONFIG = {
    OUTLOOK_CLIENT_ID: process.env.VITE_OUTLOOK_CLIENT_ID || "dfdfd781-66af-4f45-9c70-aac16217c492",
    TOPS2_CLIENT_ID: process.env.VITE_TOPS2_CLIENT_ID || "413d0be5-ef1e-473b-b80a-d176963611a4",
    AUTHORITY: "https://login.microsoftonline.com/0159e9d0-09a0-4edf-96ba-a3deea363c28",
    GRAPH_SCOPES: ["User.Read", "Mail.Send", "Mail.ReadWrite"],
    
    // Token expiry settings
    TOKEN_EXPIRY: {
        DEFAULT_EXPIRY_SECONDS: 3600, //1 hour (fallback when Azure AD doesn't provide expiry)
        REFRESH_BUFFER_MINUTES: 5,     // Refresh tokens 5 minutes before expiry
        
        // Note: Azure AD access tokens typically expire in 1 hour regardless of this setting
        // This mainly affects when we attempt token refresh and local cache management
    },
    
    // Environment URLs
    ENV_URLS: {
        local: 'https://localhost:3000',
        dev: 'https://actions.tops2-dev.cbre.com',
        stg: 'https://actions.tops2-stg.cbre.com',
        uat: 'https://actions.tops2-uat.cbre.com',
        prod: 'https://actions.tops2.cbre.com'
    }
};

// Computed values
AUTH_CONFIG.TOPS2_SCOPES = [`${AUTH_CONFIG.TOPS2_CLIENT_ID}/access_as_user`];

// Helper function to get current environment
AUTH_CONFIG.getCurrentEnvironment = function() {
    if (typeof window === 'undefined') return 'dev';
    
    const hostname = window.location.hostname;
    if (hostname === 'localhost') return 'local';
    if (hostname.includes('-dev')) return 'dev';
    if (hostname.includes('-stg')) return 'stg';
    if (hostname.includes('-uat')) return 'uat';
    return 'prod';
};

// Helper function to get redirect URI
AUTH_CONFIG.getRedirectUri = function() {
    const env = this.getCurrentEnvironment();
    return `${this.ENV_URLS[env]}/taskpane.html`;
};

export default AUTH_CONFIG;
